import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { Toolbars as ToolBarContainer } from '../../../components/Card/CardHeaderWithToolbars'

const Toolbars = props => (
  <ToolBarContainer>
    <Link
      title="Create Disbursement"
      className="btn btn-primary btn-sm with-toolbars__toolbars__btn"
      to={'/disbursements/create'}
    >
      <i className="fa fa-plus"></i>
    </Link>
    <Button
      title="Refresh"
      className="with-toolbars__toolbars__btn"
      size="sm"
      color="info"
      onClick={props.onRefreshList}>
      <i className="fa fa-refresh"></i>
    </Button>
    <Button
      title="Reset filter"
      className="with-toolbars__toolbars__btn"
      size="sm"
      color="warning"
      onClick={props.onResetFilter}>
      <i className="fa fa-ban"></i>
    </Button>
    <Button
      title="Search and Filter Data"
      size="sm"
      className={classNames("with-toolbars__toolbars__btn",{"btn-danger":props.isOpen})}
      onClick={props.onToggleFilter}>
      <i className={classNames("fa",{"fa-sliders":!props.isOpen, "fa-minus":props.isOpen})}></i>
    </Button>
    <Button
      type="button"
      color="success"
      title="Export Data"
      size="sm"
      className={classNames('with-toolbars__toolbars__btn',{'btn-success':props.isOpenExport})}
      onClick={props.onToggleExport}
    >
      <i className={classNames('fa', {'fa-envelope-o':!props.isOpenExport,'fa-minus':props.isOpenExport})}></i>
    </Button>
  </ToolBarContainer>
)
export default Toolbars;

Toolbars.propTypes = {
  isOpen: propTypes.bool,
  onToggleFilter: propTypes.func,
  onResetFilter: propTypes.func,
  onRefreshList: propTypes.func,
  onToggleExport: propTypes.func
}
Toolbars.defaultProps = {
  isOpen: false,
	isOpenExport: false
}